'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$83() {
  this.bp1 = null;
  this.bp2 = false;
}
export { $c_Lpresto_PrestoRouter$$anon$83 as $c_Lpresto_PrestoRouter$$anon$83 };
$p = $c_Lpresto_PrestoRouter$$anon$83.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$83;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$83() {
}
export { $h_Lpresto_PrestoRouter$$anon$83 as $h_Lpresto_PrestoRouter$$anon$83 };
$h_Lpresto_PrestoRouter$$anon$83.prototype = $p;
$p.c1 = (function() {
  if ((!this.bp2)) {
    this.bp1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_T$package$EmptyTuple$();
    this.bp2 = true;
  }
  return this.bp1;
});
$p.P = (function() {
  return this.c1();
});
var $d_Lpresto_PrestoRouter$$anon$83 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$83, "presto.PrestoRouter$$anon$83", ({
  P0: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$83 as $d_Lpresto_PrestoRouter$$anon$83 };
//# sourceMappingURL=presto.-Presto-Router$$anon$83.js.map
